import "./HeaderButtons.scss";

import React, { ReactNode, useEffect, useRef } from "react";

type HeaderButtonsType = { id: string; render: ReactNode };

interface HeaderButtonsProps {
  activeButton: string;
  setActiveButton?: (button: string) => void;
  buttons: HeaderButtonsType[];
  showHelpMeWith?: boolean;
}

const HeaderButtons: React.FC<HeaderButtonsProps> = ({
  activeButton,
  setActiveButton,
  buttons,
}) => {
  const activeIndex = buttons.findIndex((button) => button.id === activeButton);
  const wrapperRef = useRef<HTMLDivElement>(null);

  // On phones the tabs scroll horizontally: keep the active one visible.
  useEffect(() => {
    const wrapper = wrapperRef.current;
    const active = wrapper?.querySelector<HTMLElement>(".activeButton");
    if (!wrapper || !active) {
      return;
    }
    const left = active.offsetLeft - wrapper.offsetLeft;
    const right = left + active.offsetWidth;
    if (left < wrapper.scrollLeft) {
      wrapper.scrollLeft = left;
    } else if (right > wrapper.scrollLeft + wrapper.clientWidth) {
      wrapper.scrollLeft = right - wrapper.clientWidth;
    }
  }, [activeButton]);

  return (
    <div className="mainContainerHeaders">
      <div className="headerButtonsWrapper" ref={wrapperRef}>
        {buttons.map((button, index) => {
          const isActive = button.id === activeButton;
          let className = "headerButtons";
          if (isActive) {
            className += " activeButton";
          }
          if (isActive) {
            className += " activeButton";
          } else if (index === activeIndex - 1) {
            className += " nextToLeftActive";
          }

          return (
            <button
              key={button.id}
              className={className}
              onClick={() => setActiveButton && setActiveButton(button.id)}
            >
              <div className="buttonContent">{button.render}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default HeaderButtons;
